// import { EventModel } from "../Event/EventModel"

import { SubscriberReservationModel } from "../Subscriber/SubscriberReservationModel";

export class ReservationModel {
    constructor (
        public id?: string,
        public note?: string,
        public createDate?: string,
        public eventId?: string,
    //   public event?: EventModel,
        public numberOfPeoples?: number,
        public numberOfTables?: number,
        public reservationStatus?: string,
        public subscriberId?: string,
        public subscriber?: SubscriberReservationModel,
    ) {}
}

export class ReservationDetailsModel {
    constructor (
        public id?: string,
        public note?: string,
        public createDate?: string,
        public eventId?: string,
    //   public event?: EventModel,
        public numberOfPeoples?: number,
        public numberOfTables?: number,
        public reservationStatus?: string,
        public reservationDate?: string,
        public arrivalTime?: string,
        public subscriberId?: string,
        public subscriber?: SubscriberReservationModel,

    ) {}
}

export class ReservationListRequest {
    constructor (
        public eventId?: string,
    ){}
}

export class ReservationDetailRequest {
    constructor (
        public reservationId?: string,
    ) {}
}

export class ApproveReservationRequest {
    constructor (
        public reservationId?: string,
        public note?: string,
        public subscriberName?: string,
        public subscriberEmail?: string,
    ) {}
}

export class RefuseReservationRequest {
    constructor (
        public reservationId?: string,
        public note?: string,
        public subscriberName?: string,
        public subscriberEmail?: string,
    ) {}
}